import styled from '@emotion/styled';

export const Title = styled.h2`
  margin-top: 15px;
  margin-bottom: 10px;
  text-align: center;
`;

export const ViewSwitcherWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
`;

export const EmptyState = styled.p`
  margin: 20px 0;
  text-align: center;
  color: inherit;
  opacity: 0.85;
`;
